// eslint-disable import/no-extraneous-dependencies
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

export const firebaseConfig = {
  apiKey: 'AIzaSyDYLTRtGyR8NF5_a08vzGrV0GSJv_jr4z8',
  authDomain: 'bodycount-bd8d4.firebaseapp.com',
  projectId: 'bodycount-bd8d4',
  storageBucket: 'bodycount-bd8d4.firebasestorage.app',
  messagingSenderId: '861068546341',
  appId: '1:861068546341:web:72870ba2cec3986fdc0acc',
  measurementId: 'G-KCSXSW339E',
};

const app = initializeApp(firebaseConfig);

export const firebaseApp = app;

export const firestore = getFirestore(app);

export const functions = getFunctions(app);

export const storage = getStorage(app);

// Messaging is initialized lazily in App.jsx to avoid service worker errors on native platforms
